export default{
	name : 'insurance_dialog',
	props:{
		show : Boolean
	},
	data () {
		return {}
	},
	methods : {
		close() {
			this.$emit('close');
		},
		sbfw() {
			// window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3dopenid%26redirect%3dservice.sbfw%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
			window.location.href='https://user.cs96111.com/ad/record/url/auth?data=11;42;1';
		},
		gjj() {
			// window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3dopenid%26redirect%3dservice.gjj%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
			window.location.href='https://user.cs96111.com/ad/record/url/auth?data=11;43;1';
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/insurance_dialog/insurance_dialog.controller.js